import React from 'react';

export const Blade76 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <defs>
        <circle id="prefix__blade76" cx={44.2} cy={44.2} r={43.5} />
      </defs>
      <clipPath id="prefix__blade76b">
        <use xlinkHref="#prefix__blade76" overflow="visible" />
      </clipPath>
      <g
        clipPath="url(#prefix__blade76b)"
        fill="#fff"
        stroke="#233762"
        strokeWidth={4.853}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      >
        <path d="M49.2 96.6L-9 91c-3.1-.3-5.4-2.9-5.4-5.9V70.7c0-3.5 3-6.2 6.5-5.9L58 70.6c4.3.4 6.8 5 4.7 8.8L55 93.5c-1.2 2.1-3.4 3.3-5.8 3.1z" />
        <path d="M49.2 77L-9 71.4c-3.1-.3-5.4-2.9-5.4-5.9V51.1c0-3.5 3-6.2 6.5-5.9L58 51c4.3.4 6.8 5 4.7 8.8L55 73.9c-1.2 2.1-3.4 3.3-5.8 3.1z" />
        <path d="M49.2 57.3L-9 51.7c-3.1-.3-5.4-2.9-5.4-5.9V31.4c0-3.5 3-6.2 6.5-5.9L58 31.4c4.3.4 6.8 5 4.7 8.8L55 54.3c-1.2 2.1-3.4 3.3-5.8 3z" />
        <path d="M49.2 37.7L-9 32.1c-3.1-.3-5.4-2.9-5.4-5.9V11.8c0-3.5 3-6.2 6.5-5.9L58 11.7c4.3.4 6.8 5 4.7 8.8L55 34.6c-1.2 2.1-3.4 3.3-5.8 3.1z" />
      </g>
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="none"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
    </svg>
  );
};
